/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const membershipEndBodyExpectedVersionExclusiveMin = 0;
export const membershipEndBodyExpectedVersionMax = 9007199254740991;

export const MembershipEndBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(membershipEndBodyExpectedVersionExclusiveMin)
    .max(membershipEndBodyExpectedVersionMax),
});

export type MembershipEndBody = zod.input<typeof MembershipEndBody>;
export type MembershipEndBodyOutput = zod.output<typeof MembershipEndBody>;
